"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MysteryBoxStatus = void 0;
var MysteryBoxStatus;
(function (MysteryBoxStatus) {
    MysteryBoxStatus["ACTIVE"] = "ACTIVE";
    MysteryBoxStatus["INACTIVE"] = "INACTIVE";
})(MysteryBoxStatus || (exports.MysteryBoxStatus = MysteryBoxStatus = {}));
//# sourceMappingURL=box.js.map